import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=4ad2744e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad2744e')) {
      api.createRecord('4ad2744e', component.options)
    } else {
      api.reload('4ad2744e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=4ad2744e&", function () {
      api.rerender('4ad2744e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h3AAIEzH6t42/JS/comp/childrenage.vue"
export default component.exports